import { type LogRecord, type Sink, configureLogging } from '@awpmarine/core/logger';
import { type AnyValue, sendEvent } from '@dash0/sdk-web';

import { env } from '@/env';

import { enabled } from './dash0';

/** Rides the pipeline `./dash0` already started, rather than a second transport. */
function dash0Sink(): Sink {
  return ({ level, ...record }: LogRecord) => {
    sendEvent('log', {
      title: record.message.map((part) => (typeof part === 'string' ? part : String(part))).join(''),
      timestamp: record.timestamp,
      severity: level === 'warning' ? 'WARN' : (level.toUpperCase() as Uppercase<typeof level>),
      attributes: { category: record.category.join('.'), ...record.properties } as Record<string, AnyValue>,
    });
  };
}

/** Browser logging. Side-effect import before the first render, the way `./dash0` is. */
void configureLogging({
  level: env.VITE_LOG_LEVEL,
  ...(enabled ? { sinks: { dash0: dash0Sink } } : {}),
});
